/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/

export default {
  'standard': {
    '用户不存在': 'Akun ini belum terdaftar, silahkan daftar terlebih dahulu lalu login',
    'no_zone_code': '(tidak diperlukan kode area)',
    '授权校验失败，请刷新页面并重试。': 'Verifikasi otorisasi gagal, perbarui halaman dan coba lagi',
    'onlineService': 'Online<br/>Layanan Pelanggan Online<br/>',
    'eParcel': 'Paket ABX',
    'overseasFulfilment': 'Pengiriman ekspres e-niaga ABX',
    'warehouse': 'Gudang luar negeri',
    'standardExpress': 'Ekspres standar ABX',
    'economyExpress': 'Penawaran Spesial ABX',
    'heavyFreight': 'Barang berat ABX',
    'pleaseAgreePolicy': 'Harap membaca dan menyetujui Kebijakan Privasi terlebih dahulu',
    'pleaseAgreeToScan': 'Harap centang Kebijakan Privasi di sebelah kanan terlebih dahulu',
    '验证码接收方式': 'Cara menerima kode verifikasi',
    'cancelTips': 'Harap membaca dan menyetujui perjanjian pembatalan akun',
    'confirmCancel': 'Konfirmasikan logout',
    'verificationCodeError': 'Kode verifikasi salah, silakan dapatkan kode verifikasi lagi!',
    'clickGoDirectly': '(Klik untuk langsung menuju)',
    'repeatTips': 'Ada masalah duplikasi di akun Anda. Silakan buka <span class="mode">Pilih metode login</span> dan login. Ini akan otomatis lanjut setelah {count} detik.',
    'repeatTips1': 'Ada masalah duplikat dengan nomor ponsel Anda. Silakan buka <span class="mode">Pilih kode area</span> dan masuk. Ini akan otomatis lanjut setelah {count} detik.',
    'goOldLogin': 'Login versi lama',
    'goNewLogin': 'Masuk versi baru',
    'siteTips': 'Untuk pengalaman sistem yang lebih baik, Anda dapat memilih untuk beralih ke negara atau wilayah lain',
    'siteGo': 'Pergi ke',
    'loginLoading': 'Akun otomatis login ke sistem baru, harap tunggu.',
    'sfExpress': 'Hak Cipta © 2024 SF Express, semua hak dilindungi',
    'kex': 'KEX',
    'iuopOsPatent': 'Hak Cipta © 2024 SF Express, semua hak dilindungi',
    'unite': 'Pusat Layanan Sertifikasi ABX',
    'jumpError': 'Alamat lompat itu ilegal',
    'tips': 'petunjuk',
    'tips1': 'Tip yang baik',
    'confirm': 'mengonfirmasi',
    'agreeAndContinue': 'Saya telah membaca dan menyetujui Kebijakan Privasi',
    'agreeService': 'Saya telah membaca dan menyetujui Ketentuan Layanan',
    'agreeUserAgreement': 'Saya telah membaca dan menyetujui "Perjanjian Pengguna"',
    'define': 'Tentu',
    'cancel': 'Membatalkan',
    'yes': 'Ya',
    'no': 'TIDAK',
    'sendAgain': 'Kirim ulang',
    'second': 'Kedua',
    'iknow': 'Jadi begitu',
    'country': 'Negara/Wilayah',
    'tel': 'Nomor telepon',
    'email': 'Surat',
    'telNumber': 'nomor telepon',
    'verifyCode': 'Kode verifikasi',
    'sendVerificationCode': 'Kirim kode verifikasi',
    'next': 'Langkah selanjutnya',
    'prev': 'Langkah sebelumnya',
    'finished': 'Menyelesaikan',
    'back': 'kembali',
    'backLogin': 'Kembali ke login',
    'home': 'Situs Resmi SF International',
    'home_os': 'ABX',
    'inquiry': 'Pertanyaan',
    'add': 'Baru',
    'edit': 'sunting',
    'del': 'menghapus',
    'batchDel': 'Hapus sebagian',
    'operating': 'beroperasi',
    'clearInfo': 'Informasi yang jelas',
    'excelUpload': 'Unggah Excel',
    'serialNumber': 'nomor seri',
    'save': 'menyimpan',
    'leastOne': 'Silakan periksa terlebih dahulu data yang ingin Anda hapus',
    'uploadFile': 'Unggah file',
    'downloadExcel': 'Unduh templat EXCEL',
    'pleaseInput': 'Silakan masuk',
    'pleaseSelect': 'Silakan pilih',
    'isDel': 'Apakah Anda yakin ingin menghapus data yang dipilih?',
    'agree': 'setuju',
    'disagree': 'tidak setuju',
    'uploadTotal': 'Total unggahan',
    'uploadSuccess': 'Unggahan berhasil',
    'uploadFail': 'Gagal mengunggah',
    'checkAll': 'Pilih semua',
    'cancelContent': 'Akun ini telah diajukan untuk dibatalkan pada [{cancelTime}]. Jika Anda login dalam waktu 15 hari, akun tersebut akan diaktifkan kembali.',
    'ok': 'OKE',
    'autoTip': 'Otentikasi sedang berlangsung, harap tunggu...',
    'feedback': 'Menampilkan umpan balik/saran',
    'scanCode': 'Pindai kode QR untuk masuk',
    'useWxScan': 'Pindai menggunakan WeChat',
    'useWhatsAppScan': 'Pindai menggunakan WhatsApp',
    'otherLoginWays': 'Metode masuk lainnya',
    'scanSuccessfully': 'Pindai kode berhasil',
    'confirmOnPhone': 'Silakan konfirmasi di ponsel Anda',
    'refreshQR': 'Klik untuk menyegarkan',
    'consult': 'Konsultasi kerjasama',
    'please_select_correct_phone': 'Silakan pilih kode area ponsel yang benar',
    '国际标快': 'ekspres standar internasional',
    '国际特惠': 'Spesial Internasional',
    '顺丰集运': 'Jalur Kontainer SF',
    '国际电商专递': 'Pengiriman ekspres e-commerce internasional',
    '国际小包': 'paket kecil internasional',
    '海外仓': 'Gudang luar negeri',
    '顺丰国际产品导航': 'Navigasi produk',
  },
  'channel': {
    'gls': 'GLS',
    'gls_tooltip': 'Silakan isi login akun di badan email, subjek email [GLS Lupa Kata Sandi], dan kirim email ke wuzipeng@sf-express.com'
  },
  'login': {
    'toLogin': 'Pergi untuk masuk',
    'account': 'akun',
    'accountRepeativeTitle': 'Pemrosesan duplikasi akun',
    'accountRepeativeDesc': 'Akun Anda diduplikasi dan Anda perlu mengonfirmasi akun mana yang akan Anda gunakan untuk masuk ke sistem. Anda juga dapat memilih untuk keluar atau masuk ulang ke salah satu akun setelah masuk untuk menghindari situasi serupa di masa mendatang.',
    'accountType': 'Jenis akun',
    'aciton': 'beroperasi',
    'merge': 'Versi fusi tiga elemen',
    'unique': 'Versi independen tiga elemen',
    'selectLoginType': 'Pilih metode masuk',
    'personal': 'Login pribadi',
    'enterprise': 'Login perusahaan',
    'tel': 'Nomor telepon',
    'password': 'kata sandi',
    'verificationCodeLogin': 'Login kode verifikasi',
    'verificationCode': 'Kode verifikasi',
    'obtainVerificationCode': 'Dapatkan kode verifikasi',
    'passwordLogin': 'Masuk kata sandi',
    'rememberPSD': 'ingat aku',
    'rememberTips': 'Tidak disarankan untuk seleksi pada perangkat publik',
    'forgetPSD': 'lupa kata sandinya',
    'loginAgree': 'Saya telah membaca dan setuju',
    'agreeTips': 'Kebijakan Privasi',
    'userAgreement': 'Perjanjian Pengguna',
    'login': 'Masuk',
    'username': 'nama belakang',
    'email': 'Surat',
    'phoneLogin': 'Login nomor ponsel',
    'usernameLogin': 'Masuk nama pengguna',
    'emailLogin': 'masuk email',
    'usernameOrEmailLogin': 'Login nama pengguna/email',
    'registerNow': 'Daftar sekarang',
    'pleaseInput': 'Silakan masuk',
    'and': 'Dan',
    'sfbuy_privacy': '"Perjanjian Layanan Konsolidasi"',
    'sfbuy_title': 'Konsolidasi',
    'aboutUs': 'tentang Kami',
    'serviceGuide': 'Panduan Pemula',
    'helpCenter': 'Pusat Bantuan',
    'serviceAndPrice': 'Layanan dan harga',
    'onlineCSR': 'Layanan pelanggan daring',
    'copyright': 'Hak cipta'
  },
  'register': {
    'personal': 'Pendaftaran pengguna pribadi',
    'enterprise': 'Pendaftaran pengguna perusahaan',
    'tel': 'Nomor telepon',
    'telVerificationCode': 'Kode verifikasi ponsel',
    'email': 'Surat',
    'emailVerificationCode': 'Isi kode verifikasi email',
    'sendVerificationCode': 'Kirim kode verifikasi',
    'password': 'Silakan masukkan kata sandi',
    'passwordAgain': 'Silakan masukkan kata sandi lagi',
    'agree': 'Saya telah setuju',
    'termsOfService': 'Ketentuan Layanan',
    'SFBuyService': 'Perjanjian Layanan Konsolidasi SF',
    'and': 'Dan',
    'privacyPolicy': 'Kebijakan Privasi',
    'registerNow': 'Daftar sekarang',
    'haveUserName': 'Sudah punya akun?',
    'loginNow': 'Masuk sekarang',
    'toEmail': 'Pendaftaran email',
    'toTel': 'Registrasi ponsel',
    'invitationCode': 'Silakan masukkan kode pendaftaran/undangan VIP',
    'timeCount': '(Sisa {count} detik, harap baca sampai akhir)',
    'readBottom': '(Harap baca sampai akhir)',
    'isFinshRead': 'Harap baca dan setujui informasi ketentuan'
  },
  'resetPassword': {
    'resetTel': 'pengaturan ulang telepon',
    'resetEmail': 'Reset kotak surat',
    'tel': 'Nomor telepon',
    'telVerificationCode': 'Kode verifikasi ponsel',
    'email': 'Surat',
    'emailVerificationCode': 'Kode verifikasi email',
    'sendVerificationCode': 'Kirim kode verifikasi',
    'newPassword': 'Kata Sandi Baru',
    'confirmNewPassword': 'Konfirmasikan kata sandi baru',
    'resetPassword': 'mengatur ulang kata sandi',
    'back': 'kembali',
    'login': 'Masuk',
    'register': 'daftar'
  },
  'modifyPassword': {
    'changePassword': 'Ubah kata sandi',
    'old': 'Kata Sandi Lama',
    'new': 'Kata Sandi Baru',
    'confirm': 'Konfirmasikan kata sandi baru'
  },
  'cookies': {
    'tip1': 'Situs web kami menggunakan cookie untuk mengoptimalkan pengalaman dan analisis pengguna. Kami dapat membagikan informasi Anda dengan mitra analitik kami.',
    'tip2': 'Kebijakan Cookie',
    'tip3': 'Berikan informasi lebih lanjut. Untuk mengubah pengaturan Anda, klik',
    'tip4': 'Di Sini',
    'tip5': '. Dengan mengklik Setuju, Anda menyetujui penggunaan cookie sesuai dengan preferensi Anda.',
    'disAgree': 'menolak',
    'cookieSet': 'Pengaturan kue',
    'preference': 'Kelas preferensi',
    'optimisation': 'Kelas optimasi',
    'analytics': 'Analisa',
    'neddCheck': 'Anda harus memeriksa kategori preferensi terlebih dahulu',
    'cookie': 'Kebijakan cookie',
    'agree': 'setuju',
    'preferenceCenter': 'pusat preferensi'
  },
  'slideCircus': {
    'title': 'Konfirmasi informasi akun',
    'change': 'Ubah itu',
    'right': 'Silakan tahan penggeser dan seret ke kanan untuk menyelesaikan teka-teki',
    'pass': 'Verifikasi berhasil',
    'verifyText': 'Silakan klik tombol untuk memverifikasi',
    'verifying': 'Teka-teki sedang diverifikasi...',
    'loading': 'Memuat gambar',
    'error': 'Panggilan layanan penggeser gagal'
  },
  'message': {
    'slideError': 'Panggilan layanan penggeser gagal',
    'selectTerms': 'Harap tinjau dan periksa syarat dan ketentuan',
    'verifyPass': 'Silakan klik tombol untuk memverifikasi',
    'registerSuccess': 'Pendaftaran berhasil',
    'sendTips0': 'Berhasil dikirim',
    'resetPasswordTips0': 'Penyetelan ulang kata sandi berhasil',
    'loginTips0': 'Masuk berhasil',
    'loginTips1': 'Login berhasil, akun telah diaktifkan',
    'modifiedTips0': 'Modifikasi berhasil',
    'switchLanguage': 'Peralihan bahasa berhasil',
    'switchSite': 'Berhasil berpindah negara',
    'changeTel': 'Selamat, ponsel Anda telah berhasil dimodifikasi, silakan login kembali!',
    'ChangeEmail': 'Selamat, alamat email Anda telah berhasil diubah, silakan login kembali!',
    'cancelSuccess': 'Selamat, akun Anda telah berhasil dibatalkan!',
    'imgType': 'Silakan pilih ulang gambar. Hanya format JPG dan PNG yang didukung untuk mengunggah gambar!',
    'imgSize': 'Silakan pilih ulang gambar, ukuran gambar tidak boleh melebihi 3MB!',
    'submitSuccess': 'Pengiriman berhasil',
    'setSuccess': 'Penyiapan berhasil',
    'delSuccess': 'Hapus berhasil',
    'addSuccess': 'Berhasil ditambahkan',
    'fileType': 'Silakan pilih ulang file tersebut. File hanya mendukung format xls dan xlsx!',
    'fileSize': 'Silakan pilih ulang file tersebut, ukuran file tidak boleh melebihi 15MB!',
    'delError': 'Penghapusan gagal, coba lagi nanti',
    'uploadFile': 'Silakan unggah file',
    'uploadFileSuccess': 'Unggahan berhasil',
    'selectedOne': 'Isi setidaknya satu formulir informasi bea cukai atau tanggal lahir',
    'imgTips1': 'Harap unggah gambar dalam format {imgType}',
    'imgTips2': 'Satu gambar tidak boleh melebihi 3MB',
    'imgTips3': 'Satu gambar tidak boleh melebihi 10MB',
    'imgTips4': 'Pratinjau file PDF belum didukung',
    'checkProduct': 'Silakan pilih produk',
    'clauseAgree': 'Harap setujui "Ketentuan Kontrak Waybill Elektronik"',
    'estimatedCost': 'Silakan masukkan perkiraan biaya di formulir layanan tambahan',
    'cardCode': 'Silakan masukkan nomor kartu koleksi pada formulir layanan tambahan',
    'threeTips': 'Informasi barang kurang lengkap, mohon dicek kembali',
    'fourTips': 'Informasi pesanan tidak lengkap, silakan periksa kembali',
    'noNeedUpload': 'Tidak perlu mengunggah dokumen',
    'phoneOrFixAtLeastOne': 'Silakan isi setidaknya satu nomor ponsel dan nomor telepon rumah',
    'customerOrderNo': 'Silakan masukkan nomor pesanan pelanggan',
    'mas_003038': 'Ada yang salah dengan akun login Anda, harap perbarui halaman dan coba lakukan pemesanan lagi.',
    'mas_003038_HTM': 'Ada kendala pada login Anda (nomor ponsel). Silakan perbarui halaman dan coba lakukan pemesanan lagi.',
    'mas_003035': 'Akun Anda telah terdaftar. Silakan login langsung dari IUOP untuk melakukan pemesanan ABX.',
    'mas_auth_failed': 'Otentikasi gagal'
  },
  'verify': {
    'selectAreaCode': 'Silakan pilih kode negara/area',
    'telTips': 'Silakan masukkan nomor ponsel',
    'telError': 'Silakan masukkan nomor ponsel yang benar',
    'companyNameTrue': 'Silakan masukkan nama perusahaan yang benar',
    'fixMobileCode': 'Silakan pilih kode area telepon tetap',
    'fixMobileNumber': 'Silakan masukkan nomor telepon tetap',
    'fixMobileNumberReg': 'Silakan masukkan nomor telepon tetap yang benar',
    'mobileVerificationCode': 'Isi kode verifikasi ponsel',
    'emailAddress': 'Silakan masukkan email',
    'emailTips': 'Silakan masukkan email yang benar',
    'emailVerificationCode': 'Isi kode verifikasi email',
    'password': 'Silakan masukkan kata sandi',
    'passwordError': 'Kata sandi harus terdiri dari 8-20 karakter dan hanya mendukung 3 atau lebih kombinasi huruf besar dan kecil, angka, dan simbol',
    'passwordAgain': 'Silakan masukkan kata sandi lagi',
    'passwordNotSame': 'Kata sandi yang dimasukkan dua kali tidak cocok',
    'usernameTips': 'Silakan masukkan nama pengguna',
    'usernameEmailTips': 'Silakan masukkan nama pengguna/email',
    'telEmailTips': 'Silakan masukkan nomor ponsel (tanpa kode area)/email',
    'fixTelEmailTips': 'Silakan masukkan nomor ponsel yang benar (tanpa kode area)/email',
    'selectTerms': 'Harap tinjau dan periksa syarat dan ketentuan',
    'accountName': 'Mendukung 6-20 karakter yang dimulai dengan huruf, dapat berisi huruf, angka dan garis bawah',
    'verifyType': 'Silakan pilih metode verifikasi',
    'verifyCode': 'Isi kode verifikasi',
    'lastNameRequired': 'Nama belakang tidak boleh kosong',
    'firstNameRequired': 'Nama depan tidak boleh kosong',
    'genderRequired': 'Jenis kelamin tidak boleh kosong',
    'birthdayRequired': 'Tanggal lahir tidak boleh kosong',
    'certTypeRequired': 'Jenis dokumen tidak boleh kosong',
    'certNoRequired': 'Nomor dokumen tidak boleh kosong',
    'certExpireDateRequired': 'Tanggal kedaluwarsa dokumen tidak boleh kosong',
    'notSupTips': 'Tidak mendukung angka dan karakter khusus lainnya',
    'certImage': 'Silakan unggah gambar dokumen sebelum mengirim',
    'commodityName': 'Silakan masukkan nama barang yang dikirim',
    'quantity': 'Silakan masukkan jumlah',
    'unit': 'Silakan pilih unit',
    'unitPrice': 'Silakan masukkan harga satuan',
    'placeOfOrigin': 'Silakan pilih tempat asal',
    'over0': 'Silakan masukkan angka lebih besar dari 0',
    'decimal3': 'Hanya mendukung 3 digit desimal',
    'decimal6': 'Hanya mendukung 6 digit desimal',
    'decimal10': 'Hanya mendukung 10 digit desimal',
    'productRecordNo': 'Silakan masukkan nomor registrasi inspeksi nasional yang benar',
    'hsCode': 'Silakan masukkan kode bea cukai yang benar',
    'productCustomsNo': 'Silakan masukkan nomor registrasi bea cukai yang benar',
    'contact': 'Silakan masukkan nama',
    'companyName': 'Silakan masukkan nama perusahaan',
    'country': 'Silakan pilih negara/wilayah',
    'regionFirst': 'Silakan pilih provinsi/kota/daerah',
    'roadName': 'Silakan masukkan nama jalan',
    'buildingNumber': 'Silakan masukkan nomor bangunan',
    'addressDetail': 'Silakan masukkan alamat detail',
    'addressDetailTrue': 'Silakan masukkan alamat detail yang benar',
    'postalCode': 'Silakan masukkan kode pos',
    'phoneNumber': 'Silakan masukkan nomor ponsel',
    'numberDecimal': 'Silakan masukkan angka',
    'bangmecho': 'Silakan masukkan Banmeicho',
    'shippingType': 'Silakan pilih jenis pengiriman',
    'clearanceInfo': 'Silakan pilih jenis dokumen',
    'idNumber': 'Silakan masukkan nomor dokumen',
    'idNumberIsTrue': 'Silakan masukkan nomor dokumen yang benar',
    'contactCn': 'Silakan masukkan nama Mandarin yang benar',
    'receiveType': 'Silakan pilih jenis penerimaan',
    'imgNumber': 'Unggah minimal {number} gambar',
    'papersTime': 'Silakan pilih masa berlaku dokumen',
    'declaredCurrency': 'Silakan pilih mata uang',
    'requred': 'Bidang ini wajib diisi',
    'parcelTotalWeight': 'Silakan masukkan berat total',
    'contentMaxLength18': 'Panjang konten antara 1 dan 18',
    'contentIntOrFloatMaxLength': 'Mendukung maksimal 12 digit bilangan bulat, 10 digit desimal',
    'atLeastSelectTip': 'Silakan pilih setidaknya satu catatan',
    'invitationCode': 'Silakan masukkan kode undangan yang benar',
    'characterLength': 'Panjang tidak melebihi {length} karakter',
    'pickUpTime': 'Silakan pilih waktu penjemputan yang dijanjikan',
    'onlyNumberAndLetter': 'Hanya mendukung kombinasi angka dan huruf',
    'serviceFee': 'Perkiraan biaya layanan tambahan mendukung maksimal 12 digit bilangan bulat, 2 digit desimal',
    'methoedCode': 'Nomor kartu pembayaran COD layanan tambahan mendukung maksimal 20 digit angka',
    'contentInt14OrFloat2MaxLength': 'Mendukung maksimal 14 digit bilangan bulat, 2 digit desimal',
    'contentInt10OrFloat6MaxLength': 'Mendukung maksimal 10 digit bilangan bulat, 6 digit desimal',
    'contentInt18OrFloat6MaxLength': 'Mendukung maksimal 18 digit bilangan bulat, 6 digit desimal',
    'timeZoneCode': 'Silakan pilih zona waktu',
    'contentInt14OrFloat1MaxLength': 'Mendukung maksimal 14 digit bilangan bulat, 1 digit desimal',
    'contentInt15OrFloat5MaxLength': 'Mendukung maksimal 15 digit bilangan bulat, 5 digit desimal'
  },
  'placeholder': {
    'countryCode': 'Silakan pilih kode negara/area',
    'telCode': 'kode wilayah',
    'phoneCode': 'Silakan masukkan nomor ponsel',
    'mobileVerificationCode': 'Isi kode verifikasi ponsel',
    'verificationCode': 'Isi kode verifikasi',
    'emailAddress': 'Silakan masukkan alamat email',
    'emailVerificationCode': 'Isi kode verifikasi email',
    'password': 'Silakan masukkan kata sandi',
    'checkPassword': 'Silakan masukkan kata sandi lagi',
    'enter': 'Silakan masuk',
    'userName': 'Silakan masukkan nama pengguna',
    'cardType': 'Silakan pilih jenis dokumen',
    'uploadCard': 'Tetap konsisten dengan informasi dokumen',
    'uploadCardId': 'Silakan masukkan nomor ID yang valid',
    'passwordError': 'Kata sandi harus terdiri dari 8-20 karakter dan hanya mendukung 2 atau lebih kombinasi huruf besar dan kecil, angka, dan simbol.',
    'passwordAgain': 'Masukkan kata sandi baru lagi',
    'verifyType': 'Silakan pilih metode verifikasi',
    'newEmail': 'Silakan masukkan alamat email Anda yang biasa',
    'addressBook': 'Silakan masukkan nama/nama perusahaan Anda untuk ditanyakan',
    'goodsWarehouse': 'Silakan masukkan nama kiriman/kode bea cukai yang ingin ditanyakan',
    'clearanceWaybill': 'Silakan masukkan 12 digit nomor waybill atau 15 digit nomor waybill yang diawali dengan \'SF\'',
    'parcelTotalLength': 'Silakan masukkan yang panjang',
    'parcelTotalWidth': 'Silakan masukkan lebar',
    'parcelTotalHeight': 'Silakan masukkan tinggi',
    'senderReason': 'Silakan pilih alasan pengiriman',
    'tradeCondition': 'Silakan pilih ketentuan perdagangan',
    'senderReasonContent': 'Silakan isi alasan pengiriman non-komersial',
    'businessRemark': 'Silakan isi keterangan faktur komersial',
    'pickupAppointTime': 'Pilih tanggal dan waktu (waktu penjemputan adalah 3 jam setelah janji temu Anda)',
    'remarkText': 'Teks dapat dimasukkan secara manual',
    'payMethod': 'Silakan pilih metode pembayaran',
    'payMonthCard': 'Silakan masukkan nomor rekening bulanan',
    'taxPayMethod': 'Silakan pilih metode pembayaran pajak',
    'taxPayMonthCard': 'Silakan masukkan nomor rekening pelunasan pajak',
    'serviceFee': 'Silakan masukkan perkiraan biaya',
    'feeCard': 'Silakan masukkan nomor kartu koleksi',
    'invitationCode': 'Silakan masukkan kode undangan',
    'willBay': 'Silakan masukkan nomor waybill',
    'senderCountry': 'Silakan pilih tempat asal',
    'receiverCountry': 'Silakan pilih tujuan',
    'receiverContact': 'Silakan masukkan nama penerima',
    'orderStatus': 'Silakan pilih status pesanan',
    'startTime': 'tanggal mulai',
    'to': 'ke',
    'endTime': 'tanggal akhir',
    'timeZoneCode': 'Silakan pilih zona waktu',
  },
  'tagsView': {
    'refresh': 'Segarkan',
    'close': 'Tutup',
    'closeOthers': 'Tutup yang lain',
    'closeAll': 'Tutup semua'
  },
  'exit': {
    'title': 'Keluar',
    'message': 'Konfirmasi keluar?',
    'success': 'Berhasil keluar!',
    'cancel': 'Batalkan keluar!',
    'close': 'Pembatalan berhasil',
  },
  'notFind': {
    'oops': '404',
    'info': 'Maaf, halaman yang Anda kunjungi tidak ada',
    'backHome': 'Kembali ke beranda',
  },
  'settings': {
    'title': 'Pengaturan halaman',
  },
  'role': {
    'admin': 'Administrator',
    'user': 'Pengguna umum',
  },
  'route': {
    'Login': 'Masuk',
    '顺丰国际产品导航': 'Navigasi produk',
    'Register': 'daftar',
    'ResetPassword': 'mengatur ulang kata sandi',
    'UserCenter': 'Pusat pengguna',
    'MyInfomation': 'Informasi saya',
    'AccountInfomation': 'Informasi akun',
    'BaseInfomation': 'Informasi dasar',
    'AccountSecurity': 'Keamanan akun',
    'ProtocolManage': 'Manajemen protokol',
    'BindingEmail': 'Mengikat email',
    'BindingPhone': 'Mengikat ponsel',
    'CancelAccount': 'Batalkan akun',
    'ChangeEmail': 'Ubah email',
    'ChangePassword': 'Ubah kata sandi',
    'ChangePhone': 'Ubah ponsel',
    'Name': 'Setel nama pengguna',
    'ToMail': 'Saya ingin mengirim',
    'MailProduct': 'Produk pengiriman',
    'AddressBook': 'Buku alamat',
    'GoodsWarehouse': 'Gudang barang',
    'Order': 'Manajemen pesanan',
    'OrderIndex': 'Daftar pesanan',
    'OrderAdd': 'Pemesanan tiket tunggal',
    'Clearance': 'Data bea cukai',
    'UploadPhotoid': 'Unggah dokumen identitas',
    'EditOrder': 'Edit pesanan',
    'permission': 'Manajemen izin',
    'permission_system': 'Manajemen sistem',
    'permission_role': 'Manajemen peran',
    'permission_resource': 'Izin sumber daya',
    'permission_user': 'Manajemen pengguna'
  },
  'button': {
    'sumbit': 'Kirim'
  },
  'accountInfo': {
    'username': 'Nama pengguna:',
    'firstname': 'Nama depan:',
    'lastname': 'Nama belakang:',
    'sex': 'Jenis kelamin:',
    'man': 'Pria',
    'woman': 'Wanita',
    'telNumber': 'Nomor ponsel:',
    'telNumberNot': 'Akun Anda belum terikat dengan nomor ponsel',
    'email': 'Email:',
    'emailNot': 'Akun Anda belum terikat dengan email',
    'binding': 'Ikat sekarang >',
    'changeTel': 'Ubah ponsel >',
    'changeEmail': 'Ubah email >',
    'validated': 'Terverifikasi',
    'autoGeneration': 'Dibuat otomatis',
    'usernameTips': 'Nama pengguna tidak dapat diubah setelah disetel',
    'birthday': 'Tanggal lahir:',
    'birthday1': 'Tanggal lahir',
    'autoCreate': 'Dibuat otomatis'
  },
  'baseInfo': {
    'cardType': 'Jenis dokumen:',
    'firstname': 'Nama depan:',
    'lastname': 'Nama belakang:',
    'cardId': 'Nomor dokumen:',
    'cardTime': 'Masa berlaku dokumen:',
    'cardImg': 'Gambar dokumen:',
    'cardLangTime': 'Berlaku selamanya',
    'uploadImg': 'Unggah gambar',
    'titleTips': 'Tips: Negara menerapkan sistem pengiriman dengan nama asli, dan digunakan untuk bea cukai. Informasi dokumen akan diberi watermark khusus bea cukai, ABX akan menjamin keamanan informasi Anda.',
    'dialogTitle': 'Contoh standar',
    'dialogTips': 'Foto KTP yang diunggah harus memiliki sudut yang lengkap, teks yang jelas, tanpa pantulan atau penghalang. Jika buram atau terlalu gelap, verifikasi mungkin gagal!',
    'cardUp': 'Bagian depan dokumen',
    'cardDown': 'Bagian belakang dokumen'
  },
  'emailLink': {
    'tips': 'Silakan atur kata sandi akun',
    'setPassword': 'Tetapkan kata sandi',
    'success': 'Akun telah berhasil diaktifkan',
  },
  'accountSecurity': {
    'ChangePassword': 'Ubah kata sandi',
    'ChangePasswordDesc': 'Jika Anda sudah lama tidak login dan lupa kata sandi, Anda dapat mengubah kata sandi setelah memverifikasi identitas Anda.',
    'BindingPhone': 'Ikat ponsel',
    'BindingPhoneDesc': 'Mengikat ponsel dapat digunakan untuk login ponsel, pengambilan kata sandi, pemesanan dan layanan lainnya.',
    'BindingEmail': 'Ikat email',
    'BindingEmailDesc': 'Mengikat alamat email dapat digunakan untuk login email, pengambilan kata sandi, penempatan pesanan dan layanan lainnya.',
    'SettingName': 'Tetapkan nama pengguna',
    'SettingNameDesc': 'Nama pengguna dapat digunakan sebagai akun login dan tidak dapat diubah setelah pengaturan.',
    'firstname': 'nama depan',
    'lastname': 'nama keluarga',
    'SettingRealName': 'Tetapkan nama (Pertama',
    'SettingRealNameDesc': 'Tetapkan informasi nama pribadi, yang ada sebagai atribut akun dan dapat diedit beberapa kali.',
    'immediatelySet': 'Siapkan sekarang',
    'alreadySet': 'Sudah disetel',
    'settingComplete': 'Penyiapan selesai',
    'alreadyBinding': 'Melompat',
    'userName': 'Nama belakang',
    'userNameLogin': 'Nama pengguna dapat digunakan untuk login',
    'selfCreate': 'Dibuat secara otomatis',
    'stopEdit': 'Nama pengguna tidak dapat diubah setelah ditetapkan.',
    'setOk': 'Penyiapan selesai',
    'cancelAccount': 'Keluar akun',
    'cancelAccountTips': 'Data tidak dapat dipulihkan setelah keluar, harap operasikan dengan hati-hati',
    'toCancel': 'Logout sekarang',
    'cancelToKnow': 'Perjanjian pembatalan akun',
    'cancelDesc1': '1. Setelah Anda mengajukan pembatalan, akun yang dibatalkan tidak akan dapat digunakan atau dipulihkan. Harap beroperasi dengan hati-hati dan buat cadangan semua informasi dan data terkait akun sebelum beroperasi;',
    'cancelDesc2': '2. Mengajukan pembatalan berarti Anda secara sukarela menyerahkan semua hak keanggotaan dan aset virtual di akun Anda (termasuk namun tidak terbatas pada poin keanggotaan, tingkat keanggotaan dan hak keanggotaan, kupon, dll.);',
    'cancelDesc3': '3. Setelah keluar, Anda tidak dapat lagi masuk atau menggunakan akun ini, Anda juga tidak dapat mengambil konten atau informasi apa pun di dalam atau terkait dengan akun Anda, termasuk namun tidak terbatas pada: nama pengguna, avatar, dll. (Waybill informasi akan dikumpulkan sesuai dengan Kebijakan Privasi Disimpan dalam batas waktu yang disepakati, Anda dapat memeriksa informasi rute pengiriman di situs resmi ABX melalui nomor waybill);',
    'cancelDesc4': '4. Jika Anda telah membuka akun bulanan, pembatalan akan memutus ikatan akun Anda dengan akun bulanan Anda, dan untuk terus menggunakan akun bulanan, Anda perlu membatalkan kembali akun bulanan Anda;',
    'cancelDesc5': '5. Pembatalan akun ini tidak menghilangkan tanggung jawab dan beban dari akun Anda sebelum pembatalan;',
    'cancelDesc6': '6. Permintaan pembatalan dapat dibatalkan dalam 15 hari, dan pengguna dapat membatalkan permintaan pembatalan setelah 15 hari dari tanggal pembatalan, dengan kembali masuk untuk membatalkan permintaan pembatalan.',
    'cancelAgree': 'Saya telah membaca dan menyetujui "Perjanjian Pembatalan Akun"',
    'cancelTitle': 'Pembatalan Akun',
    'cancelConfirm': 'Apakah Anda yakin ingin segera keluar akun?',
    'goBinding': 'Segera Berikat',
    'changeBinding': 'Segera Ganti Ikatan',
    'cancelTips': 'Silakan baca dan setuju ke Perjanjian Pembatalan Akun',
    'auth': 'Verifikasi Identitas',
    'finish': 'Penyiapan Selesai',
    'binding': 'Ikatan Selesai',
    'verifyType': 'Metode Verifikasi',
    'ChangePhone': 'Ubah Telepon',
    'ChangeEmail': 'Ubah Email',
    'tips1': 'Selamat, kata sandi Anda telah berhasil diubah',
    'tips2': 'Selamat, ponsel Anda telah berhasil dimodifikasi.',
    'tips3': 'Selamat, alamat email Anda telah berhasil diubah.',
    'tips4': 'Selamat, ponsel Anda telah berhasil diikat',
    'tips5': 'Selamat, alamat email Anda telah berhasil diikat.',
    'tips6': 'Selamat, nama pengguna Anda berhasil disetel',
    'pleaseFirst': 'Silakan',
    'or': 'Atau'
  },
  'accountConflict': {
    'title': 'Konfirmasi informasi akun',
    'desc1': 'Halo!',
    'desc2': 'Sistem telah mendeteksi bahwa email/nomor ponsel Anda telah terdaftar di beberapa sistem perusahaan kami. </br>Untuk meningkatkan pengalaman, silakan pilih salah satu akun login sebagai akun login terpadu untuk beberapa sistem.',
    'desc3': 'Setelah mengklik "Konfirmasi", sistem akan mengirimkan link perubahan password ke email/ponsel Anda. Harap ikuti instruksi dan simpan dengan benar.',
    'loginName': 'Nama masuk',
    'phone': 'ponsel',
    'registerSys': 'Sistem registrasi',
    'registerTime': 'Waktu pendaftaran',
    'newRegister': 'Pendaftaran baru',
    'infoVer': 'Verifikasi informasi',
    'inforVerSelect': 'Silakan pilih metode verifikasi Anda',
    'selectOne': 'Silakan pilih salah satu akun login',
    'IBS': 'Sistem manajemen pemesanan dan pengiriman luar negeri',
    'ICAS': 'Platform manajemen akun terpadu ABX',
    'IUOP': ' Platform pemesanan terpadu ABX',
    'IBSE': 'Ekspor logistik pedagang ABX',
    'PMS': 'Impor logistik pedagang ABX',
    'IBSI': 'Impor logistik pedagang ABX',
    'SFBUY': 'Belanja luar negeri dan semoga berhasil',
    'POP': 'Platform terbuka pemasok',
    'SFGOAPP': 'Platform pemesanan ABX',
    'IFTP': 'Platform pengiriman ABX',
    'OFTP': 'Platform pengiriman luar negeri'
  },
  'permission': {
    'reset': 'mengatur ulang',
    'enable': 'memungkinkan',
    'disable': 'Cacat',
    'delete': 'menghapus',
    'deleteBatch': 'Hapus sebagian',
    'remark': 'Komentar',
    'sort': 'menyortir',
    'confirm': 'Tentu',
    'cancel': 'Membatalkan',
    'operation': 'beroperasi',
    'modify': 'Merevisi',
    'select': 'Silakan pilih',
    'input': 'Silakan masukkan nama pengguna atau nomor',
    'query': 'Pertanyaan',
    'edit': 'sunting',
    'required_rule': 'Data tidak boleh kosong',
    'success': 'Operasi berhasil',
    'fail': 'Operasi gagal',
    'length_rule': 'Panjang antara karakter {min} dan {max}',
    'deleteTip1': 'Silakan nonaktifkan terlebih dahulu',
    'deleteTis': 'Apakah Anda yakin akan menghapus nama tersebut?',
    'deleteChildTis': 'Pada saat yang sama, semua sistem di bawah sistem ini akan dihapus.',
    'tis': 'petunjuk',
    'deleteBatchTis': 'Konfirmasikan untuk menghapus {num} data yang dipilih?',
    'enableTis': 'Konfirmasikan {num} data yang dipilih oleh {statusName}?',
    'msgError': 'Data operasi salah',
    'codeCheckRule': 'Memungkinkan huruf besar dan kecil, angka, "_" atau "-"',
    'checkMinCharacter': 'Silakan masukkan lebih dari {min} karakter',
    'roleType_0': 'karakter yang diciptakan sendiri',
    'roleType_1': 'administrator sistem',
    'bindResource': 'Mengikat sumber daya',
    'roleList': 'daftar peran',
    'roleAdd': 'Tambahkan peran baru',
    'roleEdit': 'Sunting peran',
    'roleConfig': 'Konfigurasikan peran',
    'childSystemName': 'Nama subsistem',
    'roleNo': 'nomor peran',
    'roleName': 'Nama karakter',
    'roleDescribe': 'deskripsi peran',
    'isSystem': 'Sistem milik',
    'roleType': 'tipe peran',
    'userStatus_0': 'Tidak diaktifkan',
    'userStatus_1': 'Diaktifkan',
    'userStatus_2': 'pra-logout',
    'userStatus_3': 'Keluar',
    'userStatus_4': 'Cacat',
    'userStatus_5': 'mengunci',
    'userRoleEdit': 'Lihat/edit peran',
    'userList': 'Daftar pengguna',
    'regtime': 'Waktu pendaftaran',
    'userCode': 'Nomor pengguna',
    'area': 'Wilayah',
    'nickName': 'nama panggilan',
    'sourceSystem': 'sistem sumber',
    'userStatus': 'negara',
    'systemList': 'Daftar sistem',
    'systemAdd': 'Tambahkan sistem baru',
    'systemModify': 'Ubah sistem',
    'systemName': 'Nama sistem',
    'systemType': 'Tipe sistem',
    'systemType_0': 'data induk',
    'systemType_1': 'sistem bisnis',
    'systemCode': 'pengkodean sistem',
    'systemStatus': 'Status sistem',
    'systemStatus_0': 'memungkinkan',
    'systemStatus_1': 'Cacat',
    'systemAddChildren': 'Tambahkan subsistem baru',
    'systemSuperior': 'sistem unggul',
    'resourceList': 'Daftar sumber daya',
    'resourceAdd': 'Tambahkan sumber daya baru',
    'resourceModify': 'Ubah sumber daya',
    'resourceName': 'Nama sumber daya',
    'resourceType': 'Jenis sumber daya',
    'resourceType_MENU': 'menu',
    'resourceType_MODULE': 'Daftar isi',
    'resourceType_WIDGET': 'tombol',
    'resourceCode': 'Pengkodean sumber daya',
    'resourceStatus': 'Status sumber daya',
    'resourceStatus_true': 'memungkinkan',
    'resourceStatus_false': 'Cacat',
    'resourceAddChildren': 'Tambahkan subitem baru',
    'resourceSuperior': 'Menu sebelumnya',
    'icon': 'gaya ikon',
    'iconActive': 'ikon aktivitas',
    'shortName': 'singkatan',
    'resourceUrl': 'URL sumber daya',
    'resourceFun': 'URL Fungsi',
    'openType': 'Metode terbuka',
    'openType_0': 'Perutean halaman',
    'openType_1': 'jendela baru',
    'pub': 'Apakah Anda memerlukan kontrol izin?',
    'pub_true': 'Ya',
    'pub_false': 'TIDAK',
    'hidden': 'Apakah akan bersembunyi',
    'hidden_0': 'Ya',
    'hidden_1': 'TIDAK',
    'selectSystem': 'Silakan pilih sistem terlebih dahulu'
  },
  'protocol': {
    'num': 'nomor seri',
    'protocolName': 'Nama protokol',
    'protocolNo': 'Nomor versi protokol',
    'signTime': 'Waktu penandatanganan',
    'remark': 'Komentar',
    'signUser': 'Tanda tangani akun',
    'signName': 'Tanda tangani nama pelanggan',
    'signChild': 'Nomor subversi protokol'
  },
  'sfbuy': {
    'wechatScane': 'Pindai di WeChat',
    'wechatScane1': 'Kuasai tepat waktu',
    'wechatScane2': 'berita WeChat',
    'onlineService': 'Layanan pelanggan daring',
    'aboutUs': 'tentang Kami',
    'serviceGuide': 'Panduan Pemula',
    'helpCenter': 'Pusat Bantuan',
    'serviceAndPrice': 'Layanan dan harga',
    'announcement': 'pengumuman',
    'important': 'penting'
  },
  weakPassword: {
    提示: 'Tip',
    账号异常提醒: 'Akun Anda menunjukkan aktivitas tidak biasa. Segera ubah kata sandi atau login menggunakan kode verifikasi/pindai QR.',
    修改密码: 'Ubah Kata Sandi',
    关闭: 'Tutup',
    账号异常处理: 'Penanganan Akun Tidak Normal',
    绑定提示: 'Harap daftarkan nomor telepon atau email terlebih dahulu, lalu ubah kata sandi',
    账号: 'Akun'
  },
  twoFactorAuth: {
    双因素认证: 'autentikasi dua faktor',
    认证方式: 'Metode autentikasi',
    为了您的账号安全: 'Untuk keamanan akun Anda, harap selesaikan verifikasi dua faktor sebelum masuk.',
    请选择绑定: 'Silakan pilih untuk mengikat:',
    请先设置您的密码: 'Silakan hubungkan email atau ponsel Anda terlebih dahulu'
  },
  sendType: {
    您当前手机区号不支持whatsapp: 'Kode area ponsel Anda saat ini tidak mendukung {noticeChanel}, silakan pilih metode lain untuk mendapatkan kode verifikasi',
    请使用绑定手机号接收验证码: 'Silakan gunakan nomor ponsel terdaftar untuk menerima kode verifikasi',
    请使用绑定邮箱接收验证码: 'Silakan gunakan email terdaftar untuk menerima kode verifikasi',
    请选择验证码接收方式: 'Silakan pilih metode penerimaan kode verifikasi'
  }
}
